<template>
  <div>
    <vue-headful title="A to Z List - Where does it Go?" />
    <p>Many items have different names and we can't list them all. If you don't find your individual item on the list below, try using categories or search.</p>
    <ul class="aToZList">
      <items-list v-for="(item, index) in items" :previousLetter="previousLetter(items[index - 1])" :item="item" :key="'content - ' + item.id"></items-list>
    </ul>
    <Feedback />
  </div>
</template>

<script>
  import ItemsList from '@/components/ItemsList';
  import Feedback from '@/components/Feedback';

  export default {
    name: 'AtoZList',
    props: { 'items' : Array },
    components: { 
      ItemsList,
      Feedback
    },
		methods: {
			previousLetter: function(item) {
        return (typeof item !== "undefined") ? item.name.charAt(0).toLowerCase() : '';
			}
		}
  }
</script>
